import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=7807e3be&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=ts&"
export * from "./SimpleModal.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=7807e3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807e3be",
  null
  
)

export default component.exports